"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const string_utils_1 = require("@/common/string_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ wrapperStyle, name, control, defaultValue, onBlurFunc = () => { }, isFeeFree, disabled, required, minimumRule, isDelivery, isFreeFormData, onFreeFormPriceChange, isDemandSurvey, }) {
    const { field: { onChange: onPriceInputChange, value: priceInputValue }, } = (0, react_hook_form_1.useController)({
        name,
        control,
        rules: { required, min: minimumRule },
        defaultValue,
    });
    const feePriceHidden = (isFeeFree && isDelivery) || isFreeFormData || isDemandSurvey;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(PriceCalcDiv, Object.assign({ className: disabled ? 'surface-bg' : 'surface-white', css: wrapperStyle }, { children: [(0, jsx_runtime_1.jsx)(react_number_format_1.default, { disabled: disabled, allowNegative: false, isAllowed: ({ value }) => Number(value) <= 99999999, decimalScale: 0, value: priceInputValue, onValueChange: e => {
                    onPriceInputChange(e.value);
                }, thousandSeparator: true, suffix: isFreeFormData || isDemandSurvey ? t('원') : undefined, placeholder: `0${t('원')}`, autoComplete: "off", pattern: "\\d*", onChange: onFreeFormPriceChange, onBlur: (e) => onBlurFunc((0, string_utils_1.numberOnly)(e.target.value)) }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "calc_price", css: { visibility: feePriceHidden ? 'hidden' : 'unset' } }, { children: [(0, string_utils_1.money)((0, string_utils_1.feePrice)(Number(priceInputValue || 0), isFeeFree, isDelivery)), t('원')] }))] })));
}
exports.default = default_1;
const PriceCalcDiv = styled_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px 7px 13px;
  border: 1px solid var(--gray-10);
  border-radius: 8px;
  :focus-within {
    border: 1px solid var(--gray-60);
  }
  input {
    width: 100%;
    border: 0;
    padding: 0 0 1px;
    font-size: 15px;
    color: var(--gray-80);
    :disabled {
      background-color: var(--surface-bg);
      -webkit-text-fill-color: var(--gray-40);
      opacity: 1;
    }
  }
  .calc_price {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 24px;
    padding: 0 4px;
    border-radius: 6px;
    background-color: var(--surface-bg);
    color: var(--gray-80);
    font-weight: bold;
    font-size: 13px;
  }
`;
